import { useEffect, useMemo, useState } from "react"
import { useMainContext } from "../../../core/contexts/main"
import { formatDate, formatNumber } from "../../../core/utils/common"
import Text from "../../../core/utils/Text"
import { FlexCenter } from "../../../styles/CommonStyles"
import { TextWithMargin } from "../../../styles/OrdersStyle"
import { Column, Row } from "../../../styles/TableStyle"
import { TransactionStatus } from "../../../styles/TransactionHistoryStyles"
import CoinImg from "../../common/CoinImg"
import FilterLayout from "../../layouts/FilterLayout"
import useTransactions from "../../../core/hooks/useTransaction"


const WalletHistoryTable = () => {
    const { main: { lang } } = useMainContext()
    const [activeTab, setActiveTab] = useState(1)
    const [type, setType] = useState('wallet')
    const [flow, setFlow] = useState('')

    const {
        bankQueries,
        bankFetching,
        bankTransactions,
        walletQueries,
        walletFetching,
        walletTransactions,
        allPages,
        setBankQueries,
        setWalletQueries,
        bankInitialState,
        walletInitialState,
    } = useTransactions()

    useEffect(() => {
        if (type === 'bank') {
            setBankQueries((prevState) => ({
                ...prevState,
                page: 1,
                query: { ...prevState.query, flow: flow },
            }))
        }
        if (type === 'wallet') {
            setWalletQueries((prevState) => ({
                ...prevState,
                page: 1,
                query: { ...prevState.query, flow: flow },
            }))
        }
    }, [type, flow])

    const transactionsData = useMemo(() => {
        if (type === 'wallet') return walletTransactions
        if (type === 'bank') return bankTransactions
    }, [type, bankFetching, walletFetching])


    return (
        <div className="flex flex-col w-full gap-2">
            <div className="flex rounded-lg bg-primaryBg dark:bg-[#2a2d35] px-2 py-1 w-fit">
                <span onClick={() => { setType("wallet") }} className={`${type === 'wallet' ? "bg-cBlue" : ""} cursor-pointer rounded-lg px-2 py-1 flex items-center justify-center`}><Text className="text-xs" tid={"coining"} /></span>
                <span onClick={() => { setType("bank") }} className={`${type === 'bank' ? "bg-cBlue" : ""} cursor-pointer rounded-lg px-2 py-1 flex items-center justify-center`}><Text className="text-xs" tid={"banking"} /></span>
            </div>
            <FilterLayout
                headers={type === 'bank' ? bankHeaders : walletHeaders}
                data={
                    type === 'bank' ? bankTransactions : walletTransactions
                }
                totalPages={type === 'bank' ? allPages.BT : allPages.WT}
                hasCoinOption={type === 'wallet'}
                hasFlowOptions
                state={
                    type === 'bank'
                        ? {
                            filterQueries: bankQueries,
                            setFilterQueries: setBankQueries,
                            initialState: bankInitialState,
                        }
                        : {
                            filterQueries: walletQueries,
                            setFilterQueries: setWalletQueries,
                            initialState: walletInitialState,
                        }
                }
                activeTab={activeTab}
                loading={type === 'bank' ? bankFetching : walletFetching}
            >
                {transactionsData?.data?.map((item) => {
                    return (
                        <Row
                            key={item._id}
                        >
                            {type === "wallet" && (
                                <Column width="20%">
                                    <FlexCenter className="gap-2">
                                        <>
                                            <CoinImg id={item.coin} className="w-5 h-5" />
                                            <span>{item?.coin?.toUpperCase()}</span>
                                        </>
                                    </FlexCenter>
                                </Column>
                            )}
                            <Column>
                                <TextWithMargin type={item.flow}>
                                    <Text tid={item.flow} />
                                </TextWithMargin>
                            </Column>
                            <Column width="20%" number>
                                <div className="flex flex-col gap-1">
                                    <span>{formatDate(item.createdAt, "time", lang)}</span>
                                    <span>{formatDate(item.createdAt, "date", lang)}</span>
                                </div>
                            </Column>

                            <Column width="20%" number>
                                {item.amount ? formatNumber(item.amount) : "--"}
                            </Column>

                            <Column width="20%">
                                <TransactionStatus status={item.status}>
                                    <Text tid={`T${item.status}`} />
                                </TransactionStatus>
                            </Column>

                        </Row>
                    )
                })}
            </FilterLayout>
        </div>
    )
}

const walletHeaders = [
    { title: "coin", width: "20%" },
    { title: "type", width: "20%" },
    { title: "date", width: "20%" },
    { title: "amount", width: "20%" },
    { title: "status", width: "20%" },
]

const bankHeaders = [
    { title: "type", width: "20%" },
    { title: "date", width: "20%" },
    { title: "amount", width: "20%" },
    { title: "status", width: "20%" },
]

export default WalletHistoryTable
